const Switch = ({
  isOn,
  onClick,
  highlightWhenOff = true,
  inputLabel = '',
}) => {
  return (
    <span
      className={`mic_permission_switch ${
        !isOn && highlightWhenOff ? 'blink-border' : ''
      }`}
    >
      <span className={`circle ${isOn ? 'on' : ''}`}>
        <input
          aria-label={inputLabel}
          type="checkbox"
          checked={isOn}
          onChange={onClick}
        />
        <span className="thumb"></span>
      </span>
      <span className="track"></span>
    </span>
  );
};

export default Switch;
